import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import DevLocaleButton from '@di-shared/features/environment/DevLocaleButton';
import {ROUTE_PATHS, routes} from '@di-shared/routes';
import ModalProvider from '@shared/modal/ModalProvider';
import RouteProvider from '@shared/route/RouteProvider';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import reportWebVitals from './reportWebVitals';
import '@kdia/assets/css/koa-uio-guide.css';
import '@di-shared/assets/css/libs.css';
import '@di-shared/assets/css/driving-insight.css';
import './index.css';
import {getMyCars} from '@di-shared/api/cci/auth';
import {defaultInit} from '@di-shared/init';
import {WebviewUtils} from '@shared/webviewUtils';

init();

async function init() {
  try {
    await defaultInit();

    // [2025-09-05:cy.seo] FIXME: 이벤트 후 제거 필요 EVENT2
    const hasVin = await getReplacedVinUrl();
    if (!hasVin) {
      return;
    }

    const router = createBrowserRouter(routes);
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 0,
        },
      },
    });

    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
      <QueryClientProvider client={queryClient}>
        <RouteProvider config={{routePaths: ROUTE_PATHS}}>
          <ModalProvider
            config={{
              modalClass: 'popup_wrap',
              bodyOpenClass: 'scroll_lock',
            }}
          >
            <RouterProvider router={router} />
            {import.meta.env.VITE_PROFILE !== 'prod' && <DevLocaleButton />}
          </ModalProvider>
        </RouteProvider>
      </QueryClientProvider>
    );
  } catch (e: any) {
    window.tempErrors.push(`init.${e.message}`);
  }
}

// [2025-09-05:cy.seo] FIXME: 이벤트 후 제거 필요 EVENT2
async function getReplacedVinUrl() {
  const currentUrl = window.location.href;
  if (currentUrl.includes('_VIN_')) {
    try {
      const {contents} = await getMyCars();
      const mainVehicle = contents.find((car) => car.isMainVehicle);

      if (mainVehicle && mainVehicle.vin) {
        const newUrl = currentUrl.replace(/_VIN_/g, mainVehicle.vin);
        WebviewUtils.close(`app://webView?isModalEntry=true&showNavigationBar=false&showToolbar=false&url=${encodeURIComponent(newUrl)}`);
        return false;
      }
      WebviewUtils.showToast('이벤트 참여를 위해 앱 업데이트 또는 차량을 등록해주세요.');
      WebviewUtils.close();
      return false;
    } catch {
      WebviewUtils.showToast('이벤트 참여를 위해 앱 업데이트 또는 차량을 등록해주세요.');
      WebviewUtils.close();
      return false;
    }
  } else {
    // 문제 없는 케이스
    return true;
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
